import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const reveal = {
  initial: { opacity: 0, y: 36 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
};

const WELCOME_IMG =
  "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/kv76mxcm_IMG_0083.webp";

export const Welcome = () => {
  const { t } = useLang();
  return (
    <section className="welcome" id="welcome" data-testid="welcome-section">
      <motion.div className="welcome__text" {...reveal}>
        <p className="label">{t.welcome.label}</p>
        <h2 className="display welcome__title">
          {t.welcome.title} <em>sand life</em>
        </h2>
        <p className="welcome__body">{t.welcome.body}</p>
        <p className="welcome__body">{t.welcome.body2}</p>
      </motion.div>
      <motion.div
        className="welcome__image"
        initial={{ opacity: 0, scale: 0.985 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
      >
        <img src={WELCOME_IMG} alt="Aegean sea" loading="lazy" data-testid="welcome-image" />
      </motion.div>
    </section>
  );
};

export default Welcome;
